module.exports = __webpack_public_path__ + "static/img/animales_33.daea1a2a.png";